import { render, staticRenderFns } from "./HomeAdministration.vue?vue&type=template&id=385ca4ff"
import script from "./HomeAdministration.vue?vue&type=script&lang=js"
export * from "./HomeAdministration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports